import { useCallback, useEffect, useRef } from "react";
import { PropiedadFormEmbedContext } from "../context/PropiedadFormEmbedContext";
import PropiedadForm from "../pages/PropiedadForm";

/**
 * Ficha completa encima del pipeline/modal sin perder el contexto debajo.
 * No usa MemoryRouter (RR7 + anidación daba pantalla en blanco): la captación
 * va por contexto y el formulario sigue bajo el mismo BrowserRouter.
 * Al cerrar, hace flush del borrador para no perder Observaciones / campos editados.
 */
export default function PropiedadFormOverlay({ fromCaptacion, returnTo, onClose, onReadyClose }) {
  const rt = typeof returnTo === "string" && returnTo.startsWith("/") ? returnTo : "/pipeline?modo=captaciones";
  const flushRef = useRef(null);
  const closingRef = useRef(false);

  const registerFlushSave = useCallback((fn) => {
    flushRef.current = typeof fn === "function" ? fn : null;
  }, []);

  const handleClose = useCallback(async (opts = {}) => {
    if (closingRef.current) return;
    closingRef.current = true;
    const skipFlush = opts?.skipFlush === true;
    try {
      const flush = flushRef.current;
      if (!skipFlush && flush) {
        try {
          await flush();
        } catch {
          /* el cierre no debe quedar bloqueado si falla la red */
        }
      }
    } finally {
      closingRef.current = false;
      onClose?.();
    }
  }, [onClose]);

  useEffect(() => {
    onReadyClose?.(handleClose);
    return () => onReadyClose?.(null);
  }, [handleClose, onReadyClose]);

  return (
    <PropiedadFormEmbedContext.Provider
      value={{
        onClose: handleClose,
        embeddedCaptacion: fromCaptacion,
        embeddedReturnTo: rt,
        registerFlushSave,
      }}
    >
      <PropiedadForm />
    </PropiedadFormEmbedContext.Provider>
  );
}
